
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../../UserPermissions.js";
import { Permissions_has, Permission, Permissions_allowsReceiverType } from "../../../Shared/Roles.js";
import { ReceiverTypeName } from "../../../Shared/User.js";
import { inspectionStatusColumnDefinition, buildInspectionLookup } from "../InspectionHelper.js";
import { SWR_getToolBoxes } from "../../../Requests/Toolbox.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, toArray, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { SelectedTab, ToolboxControl } from "../../../Widgets/ToolboxControlWidget.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import { Feature, isFeatureEnabled } from "../../../FeatureFlip.js";
import { unwrap, map, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Hierarchy_getPath } from "../../../Shared/Location.js";
import { filter, ofArray, singleton as singleton_1, toArray as toArray_1, tryFind } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { roleToString } from "../../../Shared/Helper.js";
import { Table_customPropertyColumnDefinitions } from "../../../Widgets/CustomProperties.js";
import { InfiniteTable } from "../../../Widgets/Table/InfiniteTable.js";
import { RouterModule_nav, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { getQueryParams } from "../../../Common.js";
import User_Add_Plus from "../../../../public/assets/icons/User_Add_Plus.svg";
import { TableControlElement$1, TableControl$1 } from "../../../Widgets/Table/Table.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { PropertyConfigurationVisibility } from "../../../Shared/PropertyConfiguration.js";
import { Skeleton } from "../../../Components/Skeleton.js";

function UsersOverview(props) {
    let elems;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const canReadReceivers = Permissions_allowsReceiverType(permissions, new Permission(41, []), new ReceiverTypeName(0, []));
    const canCreateUsers = Permissions_has(permissions, new Permission(53, []));
    const inspectionLookup = buildInspectionLookup(SWR_getToolBoxes().data);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems = toList(delay(() => (canReadReceivers ? append(singleton(createElement(ToolboxControl, {
        CustomerConfiguration: props.CustomerConfiguration,
        SelectedTab: new SelectedTab(1, []),
        UserData: props.UserData,
    })), delay(() => {
        let TableRows, Options;
        const columnDefinitions = toArray(delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text")), delay(() => append((props.AccountSettings.InspectionsEnabled && isFeatureEnabled(new Feature(21, []))) ? singleton(inspectionStatusColumnDefinition(inspectionLookup, (dto_1) => dto_1.Id, t)) : empty(), delay(() => append(singleton(new ColumnDefinition$1("personnelNumber", "", t("user.personnel_number"), (dto_2) => (new CellContent(0, [dto_2.PersonnelNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("emailPhoneNumber", "", t("user.email_mobile_number"), (dto_3) => {
            const matchValue = dto_3.LoginInformation;
            return (matchValue.tag === 1) ? (new CellContent(0, [matchValue.fields[0]])) : (new CellContent(0, [matchValue.fields[0]]));
        }, "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("department", "", t("user.department"), (dto_4) => (new CellContent(0, [dto_4.Department])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("location", "", t("general.location"), (dto_5) => (new CellContent(0, [defaultArg(map((location_1) => Hierarchy_getPath(props.Locations, location_1), tryFind((location) => equals(location.Id, dto_5.LocationId), props.Locations)), "")])), "locationSelect", "text")), delay(() => append(props.AccountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnitName", "", t("business_units.business_unit"), (dto_6) => (new CellContent(0, [defaultArg(dto_6.BusinessUnitNames, "")])), "select", "text")) : empty(), delay(() => append(singleton(new ColumnDefinition$1("role", "", t("general.role"), (dto_7) => (new CellContent(0, [t(concat("role.", ...roleToString(dto_7.Role)))])), "select", "text")), delay(() => append(isFeatureEnabled(new Feature(6, [])) ? singleton(new ColumnDefinition$1("archived", "", t("user.is_archived"), (dto_8) => (new CellContent(0, [dto_8.IsArchived ? t("general.yes") : t("general.no")])), "select", "text")) : empty(), delay(() => Table_customPropertyColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (dto_9) => dto_9.CustomProperties, t, props.CustomerConfiguration.Currency)))))))))))))))))))));
        return singleton(createElement(InfiniteTable, (TableRows = toArray_1(props.Users), (Options = {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultColumnFilter: unwrap(isFeatureEnabled(new Feature(6, [])) ? singleton_1({
                id: "archived",
                value: [t("general.no")],
            }) : undefined),
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(dto_10) => RouterModule_encodeParts(ofArray(["receivers", "users", dto_10.Id + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: true,
            WithQueryParameters: true,
        }, {
            ColumnDefinitions: columnDefinitions,
            Controls: toList(delay(() => (canCreateUsers ? singleton(new TableControlElement$1(0, [new TableControl$1(t("user.create_new_user"), User_Add_Plus(), (_arg) => {
                RouterModule_nav(ofArray(["receivers", "users", "new"]), 1, 1);
            }, false, false, "receiver-create")])) : empty()))),
            Options: Options,
            TableKey: "receiver-user-overview-table",
            TableRows: TableRows,
        }))));
    })) : empty()))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function UserOverviewView(props) {
    const state_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined)[0];
    const matchValue = state_1.Users;
    const matchValue_1 = state_1.CustomerConfiguration;
    const matchValue_2 = state_1.PropertyConfigurations;
    const matchValue_3 = state_1.Locations;
    const matchValue_4 = state_1.AccountSettings;
    let matchResult, accountSettings, customerConfiguration, locations, propertyConfigurations, users;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_4.fields[0];
        customerConfiguration = matchValue_1.fields[0];
        locations = matchValue_3.fields[0];
        propertyConfigurations = matchValue_2.fields[0];
        users = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(UsersOverview, {
                AccountSettings: accountSettings,
                CustomerConfiguration: customerConfiguration,
                Locations: locations,
                PropertyConfigurations: filter((propertyConfiguration) => equals(propertyConfiguration.Visibility, new PropertyConfigurationVisibility(2, [])), propertyConfigurations),
                UserData: props.UserData,
                Users: users,
            });
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

